import React from 'react';
import { Modal } from '../ui/Modal';
import { useModal } from '../../stores/uiStore';
import { useCreateAssessment } from '../../hooks/api';
import { AssessmentCreate } from '../../types/api';
import EnhancedAssessmentForm from './EnhancedAssessmentForm';

const CreateAssessmentModal: React.FC = () => {
  const modal = useModal('create-assessment');
  const createMutation = useCreateAssessment();
  
  const handleSubmit = async (data: AssessmentCreate) => {
    try {
      await createMutation.mutateAsync(data);
      modal.close();
    } catch (error) {
      // Error handling is managed by the mutation
      console.error('Failed to create assessment:', error);
    }
  };
  
  const handleCancel = () => {
    modal.close();
  };
  
  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={handleCancel}
      size="xl"
    >
      <div className="p-6">
        <EnhancedAssessmentForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={createMutation.isPending}
          defaultChildId={modal.data?.childId}
        />
      </div>
    </Modal>
  );
};

export default CreateAssessmentModal;
